import { render, staticRenderFns } from "./WChipList.vue?vue&type=template&id=54b417a6&scoped=true&"
import script from "./WChipList.vue?vue&type=script&setup=true&lang=js&"
export * from "./WChipList.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54b417a6",
  null
  
)

export default component.exports